import { UrlCollection } from "../common/url-collection";
import HomePage from "../modules/home/home.view.jsx";

export const otherRoutes = [
    {
        path: UrlCollection.Home,
        component: HomePage,
        layout: HomePage,
        exact: true
    }
];
